import { map as rxjsmap } from 'rxjs';
import { BaseServices } from './../../kuba.services';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Employee, EmployeeCourse } from '../models/index';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EmployeeCourseServices {
  item: Object;
  constructor(private http: HttpClient) {}

  // List all employees
  list(businessId: number) {
    let result: EmployeeCourse;
    return this.http
      .get(environment.BASE_URL + '/employeecourses/' + businessId).pipe(rxjsmap((result: any) => result));
  }
  portalList(userId: number) {
    let result: EmployeeCourse;
    return this.http
      .get(environment.BASE_URL + '/PortalEmployeeCourses/' + userId).pipe(rxjsmap((result: any) => result));
  }
  // List all employees contracts
  listcontract(businessId: number) {
    let result: EmployeeCourse;
    return this.http
      .get(environment.BASE_URL + '/employeecontract/' + businessId).pipe(rxjsmap((result: any) => result));
  }
  portalListContract(userId: number) {
    let result: EmployeeCourse;
    return this.http
      .get(environment.BASE_URL + '/PortalEmployeeContract/' + userId).pipe(rxjsmap((result: any) => result));
  }
  // get employee course list
  getEmployeeContractByEmployeeid(empId: number, isEmployeecourses: any) {
    let result: EmployeeCourse;
    return this.http
      .get(
        environment.BASE_URL +
          '/coursesandcontractbyemployee/' +
          empId +
          '/' +
          isEmployeecourses
      ).pipe(rxjsmap(result => result));
  }

  // retrive an employee for editing and View
  getById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employeecourse/' + id).pipe(rxjsmap((result: any) => result));
  }

  // add employee course
  add(data: any) {
    let body = JSON.stringify(data);
    return this.http
      .post(environment.BASE_URL + '/employeecourse', body).pipe(rxjsmap(result => result));
  }

  // update employee course
  update(ExistingEmployee: EmployeeCourse) {
    let result: EmployeeCourse;
    return this.http
      .put(environment.BASE_URL + '/employeecourse', ExistingEmployee).pipe(rxjsmap(result => result));
  }
  addcourseData(data: any) {
    return this.http
      .post(
        environment.BASE_URL + '/business/businesscourse/businesscourse',
        data
      ).pipe(rxjsmap(result => result));
  }
  updateCourseData(data: any) {
    return this.http
      .put(
        environment.BASE_URL + '/business/businesscourse/businesscourse',
        data
      ).pipe(rxjsmap(result => result));
  }
  deletecourseData(id: number) {
    let result: boolean;
    return this.http
      .delete(
        environment.BASE_URL +
          '/business/businesscourse/businesscourseDelete/' +
          id
      ).pipe(rxjsmap(result => result));
  }
  deleteCourse(id: number) {
    let result: boolean;
    return this.http
      .delete(environment.BASE_URL + '/employeecourse/' + id).pipe(rxjsmap(result => result));
  }
  
  // bind dropdown Course Name
  getAllByCourseName(Id: number, type: any) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/businesscourselist/' +
          Id +
          '/' +
          type
      ).pipe(rxjsmap((result: any) => (result ? result : null)));
  }
  // bind dropdown Contract Name
  getAllByContractName(Id: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/businesscontractlist/' +
          Id
      ).pipe(rxjsmap((result: any) => (result ? result : null)));
  }
  getAllByPortalCourseName(Id: number, type) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/portalbusinesscourselist/' +
          Id +
          '/' +
          type
      ).pipe(rxjsmap(result => (result ? result : null)));
  }

  getPortalBusinessCourse(portalId: number, businessId: number, type: any) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/portalbusinesscourses/' +
          portalId +
          '/' +
          businessId +
          '/' +
          type
      ).pipe(rxjsmap(result => (result ? result : null)));
  }

  GetAllPortalandBusinessCourse(portalId: number, type: any) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/portalbusinesscourses/' +
          portalId +
          '/' +
          type
      ).pipe(rxjsmap(result => (result ? result : null)));
  }
  getallPortalContractCourse(portalId: number, businessId: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/portalallcontractcourselist/' +
          portalId +
          '/' +
          businessId
      ).pipe(rxjsmap(result => (result ? result : null)));
  }
 
  checkCourseName(courseName: any) {
    return this.http
      .get(
        environment.BASE_URL +
          '/business/businesscourse/checkcoursename/' +
          courseName
      ).pipe(rxjsmap(result => result));
  }
  getEmployeeCourseDocument(courseId: number) {
    return this.http
      .get(environment.BASE_URL + '/employeecourse/' + courseId).pipe(rxjsmap(result => result));
  }
  

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
